export type FileCollection = FileList | File[];

const SUPPORTED_FILE_EXTENSIONS = new Set(['pdf', 'jpg', 'jpeg', 'png']);

export const validationSizeFile = (listFile: ArrayLike<File>, size: number = 2): boolean => {
  const mbToBytes = size * 1024 * 1024;

  for (let index = 0; index < listFile.length; index++) {
    const file = listFile[index];
    if (!file || file.size <= 0 || file.size > mbToBytes) return false;
  }

  return true;
};

export const validateMaxFile = (listFile: ArrayLike<File>, maxFile: number = 5): boolean => {
  if (listFile.length > maxFile) return false;

  return true;
};

export const validateTypeFile = (listFile: ArrayLike<File>): boolean => {
  for (let index = 0; index < listFile.length; index++) {
    const file = listFile[index];
    const extension = file?.name.split('.').pop()?.toLocaleLowerCase('pt-BR');
    if (!file || !SUPPORTED_FILE_EXTENSIONS.has(extension ?? '')) return false;
  }

  return true;
};

export const validadeFileName = (listFile: ArrayLike<File>): boolean => {
  if (listFile.length === 0) return false;

  for (let index = 0; index < listFile.length; index++) {
    const name = listFile[index]?.name?.trim() ?? '';
    const extensionSeparator = name.lastIndexOf('.');
    if (extensionSeparator <= 0 || extensionSeparator === name.length - 1) return false;
  }

  return true;
};
